import React from "react";
import Select from "react-select";
import { FormField } from "./FormField";

interface SelectOption {
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}

interface SelectFieldProps {
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void;
  options: SelectOption[];
  placeholder?: string;
  required?: boolean;
  isMulti?: boolean;
  isSearchable?: boolean;
  className?: string;
  error?: string;
}

export const SelectField: React.FC<SelectFieldProps> = ({
  label,
  value,
  onChange,
  options,
  placeholder = "선택하세요",
  required = false,
  isMulti = false,
  isSearchable = true,
  className = "",
  error,
}) => {
  const fontSize = "2rem";
  const customStyles = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: (provided: any, state: any) => ({
      ...provided,
      border: state.isFocused ? "1px solid #007bff" : "1px solid #ddd",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(0, 123, 255, 0.25)" : "none",
      fontSize,
      "&:hover": {
        border: "1px solid #007bff",
      },
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueContainer: (provided: any) => ({
      ...provided,
      padding: "0.5rem 1rem",
      fontSize,
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    singleValue: (provided: any) => ({
      ...provided,
      fontSize,
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    input: (provided: any) => ({
      ...provided,
      fontSize,
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    placeholder: (provided: any) => ({
      ...provided,
      color: "#999",
      fontSize,
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    option: (provided: any) => ({
      ...provided,
      fontSize,
      padding: "1rem",
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    menu: (provided: any) => ({
      ...provided,
      fontSize,
    }),
  };

  return (
    <FormField label={label} required={required} className={className} error={error}>
      <Select
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        isMulti={isMulti}
        isSearchable={isSearchable}
        styles={{
          ...customStyles,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          control: (provided: any, state: any) => ({
            ...customStyles.control(provided, state),
            borderColor: error ? "#e74c3c" : state.isFocused ? "#007bff" : "#ddd",
            "&:hover": {
              borderColor: error ? "#e74c3c" : "#007bff",
            },
          }),
        }}
        classNamePrefix="react-select"
      />
    </FormField>
  );
};
